<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vi">CONTENTS</a></h2><a id="page_vi">
</a><p class="toc"><a id="page_vi"></a><a href="#/xhtml/foreword">Foreword</a></p>
<p class="toc"><a href="#/xhtml/preface">Preface</a></p>
<p class="toc1"><a href="#/xhtml/intro"><span class="grey">INTRODUCTION</span><br/><span class="font"><em>It’s Not the Words; It’s the Tune</em></span></a></p>
<p class="toc1"><span href="#/xhtml/ch01" title="Link target outside of Sample"><span class="grey">CHAPTER 1</span><br/><span class="font"><em>Believing in Yourself</em></span></span></p>
<p class="toc1"><span href="#/xhtml/ch02" title="Link target outside of Sample"><span class="grey">CHAPTER 2</span><br/><span class="font"><em>Fear and Response</em></span></span></p>
<p class="toc1"><span href="#/xhtml/ch03" title="Link target outside of Sample"><span class="grey">CHAPTER 3</span><br/><span class="font"><em>Getting Others to Believe You</em></span></span></p>
<p class="toc1"><a id="page_vii"></a><span href="#/xhtml/ch04" title="Link target outside of Sample"><span class="grey">CHAPTER 4</span><br/><span class="font"><em>stepping Up Your Game</em></span></span></p>
<p class="toc1"><span href="#/xhtml/ch05" title="Link target outside of Sample"><span class="grey">CHAPTER 5</span><br/><span class="font"><em>Putting a Lion in Your Heart</em></span></span></p>
<p class="toc1"><span href="#/xhtml/ch06" title="Link target outside of Sample"><span class="grey">CHAPTER 6</span><br/><span class="font"><em>Positivity!</em></span></span></p>
<p class="toc1"><span href="#/xhtml/ch07" title="Link target outside of Sample"><span class="grey">CHAPTER 7</span><br/><span class="font"><em>The Politics of success</em></span></span></p>
<p class="toc1"><span href="#/xhtml/concl" title="Link target outside of Sample"><span class="grey">CONCLUSION</span><br/><span class="font"><em>Moving beyond Hope</em></span></span></p>
<p class="toc"><span href="#/xhtml/read" title="Link target outside of Sample">Suggested Readings</span></p>
<p class="toc"><span href="#/xhtml/ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/xhtml/author" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/about" title="Link target outside of Sample">About Jolles Associates, Inc.</span><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?04285172